export const API_URL_TES = "https://apites-psisimonline.psisim.net";
export const API_URL_AUTH = "https://apiauth.psisimonline.id";
export const API_UPLOAD = "https://ade.literasikitaindonesia.com";
